<div class="share-content" *ngIf="reasons$ | async as reasons">
  <ion-content [scrollEvents]="true">
    <ion-item class="share-header-content">
      <ion-text class="share-header">Share Promo Package</ion-text>
    </ion-item>
    <form [formGroup]="shareFormGroup" (submit)="onSendButtonClick()" class="share-form">

      <div class="share-list last-list">
        <ion-item lines="none">
          <ion-text>
            <p>Share to</p>
          </ion-text>
        </ion-item>
        <ion-item [ngClass]="getClass('firstName', 'minLength')">
          <ion-label position="stacked">
            First Name:
          </ion-label>
          <ion-input formControlName="firstName" type="text" name="name" class="input">
          </ion-input>
        </ion-item>
        <div class="rules">
          <strong>First Name rules:</strong>
          <ul>
            <li [ngClass]="getClass('firstName', 'minLength')">
              Should have at least 1 characters
            </li>
            <li [ngClass]="getClass('firstName', 'required')">
              Required
            </li>
          </ul>
        </div>

        <ion-item [ngClass]="getClass('lastName', 'minLength')">
          <ion-label position="stacked">
            Last Name:
          </ion-label>
          <ion-input formControlName="lastName" type="text" name="lastName" class="input">
          </ion-input>
        </ion-item>
        <div class="rules">
          <strong>Last Name rules:</strong>
          <ul>
            <li [ngClass]="getClass('lastName', 'minLength')">
              Should have at least 1 characters
            </li>
            <li [ngClass]="getClass('lastName', 'required')">
              Required
            </li>
          </ul>
        </div>

        <ion-item [ngClass]="getClass('emailAddress', 'email')">
          <ion-label position="stacked">
            Email Address:
          </ion-label>
          <ion-input formControlName="emailAddress" type="email" name="email" class="input">
          </ion-input>
        </ion-item>
        <div class="rules">
          <strong>Email rules:</strong>
          <ul>
            <li [ngClass]="getClass('emailAddress', 'email')">
              Should be valid
            </li>
            <li [ngClass]="getClass('emailAddress', 'required')">
              Required
            </li>
          </ul>
        </div>
      </div>
      <pptl-select-drop-down [reasons]="reasons" (valid)="isValid($event)" (selected)="selected($event)">
        <ng-container>
          <ion-label position="stacked">
            Reason For Sharing:
          </ion-label>
        </ng-container>
      </pptl-select-drop-down>
      <section class="share-conditions">
        <div class="share-conditions-content">
          <ion-checkbox color="success" [checked]="isAgree" (ionChange)="toggleCheckbox()"></ion-checkbox>
          <ion-text class="text-wrap">
            <p>
              I have read and agree to the
              <a href="https://www.sonymusic.com/terms-and-conditions/" target="_blank" class="link">terms
                and conditions.</a>
            </p>
          </ion-text>
        </div>
      </section>
      <div class="buttons">
        <ion-button type="submit" [disabled]="isInvalidForm()" shape="round"
          class="modal-up-button modal-button modal-button-send">
          <i class="fas fa-envelope icon"></i>
          <span class="modal-button-text">Send</span>
        </ion-button>
        <ion-button (click)="onCancelButtonClick()" shape="round"
          class="modal-up-button modal-button modal-button-cancel">
          <i class="far fa-times-circle icon"></i>
          <span class="modal-button-text">Cancel</span>
        </ion-button>
      </div>
    </form>
  </ion-content>
</div>
